function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm, Controller } from 'react-hook-form';
import { TextField, PasswordField } from 'seagull';
import { FormContainer, FormTitle, FormFields, VerticalFormFields, HorizontalFormFields, SubmitButtonField, ErrorMessage, Footer, FooterText, FooterLink, FormSubTitle } from "../components/FormComponents";
import { useStoreActions } from "../../../contexts";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import styles from "./SignupScreen.module.scss";
import { handlePromise } from "../../../infra/utils";
import EmailSentIllustration from "./assets/emailSentIllustration.svg";
import { useEventReporter } from "../../../event-reporter";
import { routes, UtmParams } from "../../../constants";
import GoogleButton from "../../../components/GoogleButton/GoogleButton";
import { FormSeparatorVertical } from "../components/FormSeparator";
import { emailValidation, nameValidation, requiredValidation } from 'validators';
import { useUtmsParams } from "../../../hooks/useUtmsParams";
import { errorMessages } from "../constants";
import { useLocationCommonActions } from "../../../providers/LocationProvider";
import IntuitButton from "../../../components/IntuitButton/IntuitButton";
import { useOnMount } from "../../../hooks/useOnMount";
import TermsAndPrivacyMessage from "../components/TermsAndPrivacyMessage";

//Make sure to update the hubspot schema when adding/removing fields

function SignupForm(props) {
  const {
    onSubmitted
  } = props;
  const {
    logBI,
    api
  } = useStoreActions();
  const history = useHistory();
  const {
    reportFormSubmission,
    reportToHubspot,
    prepareFormObject
  } = useEventReporter();
  const [signupInProgress, setSignupInProgress] = useState(false);
  const [signupError, setSignupError] = useState(false);
  const [errorMessage, setErrorMessage] = useState();
  const getUtms = useUtmsParams();
  const {
    getPageUrl
  } = useLocationCommonActions();
  const {
    handleSubmit,
    control,
    formState
  } = useForm({
    mode: 'onChange'
  });
  useOnMount(() => {
    const utms = getUtms();
    if (UtmParams.Referral in utms) {
      logBI(18151, {
        referrer: utms[UtmParams.Referral]
      });
    }
  });
  const onSubmit = async data => {
    const {
      fullName,
      email,
      password
    } = data;
    logBI(10206, {});
    setSignupInProgress(true);
    const signup = await handlePromise(api.auth.signup({
      fullName,
      email,
      password,
      utms: getUtms(),
      pageUrl: getPageUrl()
    }));
    if (!signup.success) {
      var _signup$error$respons;
      setSignupError(true);
      setSignupInProgress(false);
      const errorType = (_signup$error$respons = signup.error.response) === null || _signup$error$respons === void 0 || (_signup$error$respons = _signup$error$respons.data) === null || _signup$error$respons === void 0 ? void 0 : _signup$error$respons.error;
      if (errorType === 'email is invalid') {
        setErrorMessage(errorMessages.noBusinessEmailError);
      } else {
        setErrorMessage(errorMessages.generalSignupError);
      }
    } else {
      reportFormSubmission('app-sign-up', [prepareFormObject('email', email)]); //TODO - replace this with specific events
      reportToHubspot('app_sign_up_', {
        email,
        firstname: fullName.first,
        lastname: fullName.last
      });
      setSignupInProgress(false);
      onSubmitted(signup.data.email);
    }
  };
  return /*#__PURE__*/React.createElement(FormContainer, {
    id: "signup-form",
    onSubmit: handleSubmit(onSubmit),
    "data-testid": "signup-form",
    onChange: () => setSignupError(false)
  }, /*#__PURE__*/React.createElement(FormTitle, null, "Sign up"), /*#__PURE__*/React.createElement(FormSubTitle, null, /*#__PURE__*/React.createElement(FooterText, null, " Already have an account? "), /*#__PURE__*/React.createElement(FooterLink, {
    toInternalLink: routes.login,
    "data-testid": "sign-in-link"
  }, "Log in")), /*#__PURE__*/React.createElement(FormFields, null, /*#__PURE__*/React.createElement(HorizontalFormFields, {
    className: styles.formWrapper
  }, /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(HorizontalFormFields, null, /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "fullName.first",
    defaultValue: "",
    rules: nameValidation('First name', {
      required: 'Please enter a first name'
    }),
    render: _ref => {
      var _fieldState$error;
      let {
        field,
        fieldState
      } = _ref;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, field, {
        label: "First name",
        error: fieldState.isTouched && !!fieldState.error,
        helperText: fieldState.isTouched && ((_fieldState$error = fieldState.error) === null || _fieldState$error === void 0 ? void 0 : _fieldState$error.message),
        testid: "first-name-input"
      }));
    }
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "fullName.last",
    defaultValue: "",
    rules: nameValidation('Last name', {
      required: 'Please enter a last name'
    }),
    render: _ref2 => {
      var _fieldState$error2;
      let {
        field,
        fieldState
      } = _ref2;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, field, {
        label: "Last name",
        error: fieldState.isTouched && !!fieldState.error,
        helperText: fieldState.isTouched && ((_fieldState$error2 = fieldState.error) === null || _fieldState$error2 === void 0 ? void 0 : _fieldState$error2.message),
        testid: "last-name-input"
      }));
    }
  })), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "email",
    defaultValue: "",
    rules: emailValidation(undefined, {
      required: 'Please enter an email'
    }),
    render: _ref3 => {
      var _fieldState$error3;
      let {
        field,
        fieldState
      } = _ref3;
      return /*#__PURE__*/React.createElement(TextField, _extends({}, field, {
        label: "Work email",
        type: "email",
        error: fieldState.isTouched && !!fieldState.error,
        helperText: fieldState.isTouched && ((_fieldState$error3 = fieldState.error) === null || _fieldState$error3 === void 0 ? void 0 : _fieldState$error3.message),
        testid: "email-input"
      }));
    }
  }), /*#__PURE__*/React.createElement(Controller, {
    control: control,
    name: "password",
    defaultValue: "",
    rules: _objectSpread(_objectSpread({}, requiredValidation('Please enter a password')), {}, {
      minLength: {
        value: 10,
        message: 'Use 10 or more characters'
      }
    }),
    render: _ref4 => {
      var _fieldState$error4;
      let {
        field,
        fieldState
      } = _ref4;
      return /*#__PURE__*/React.createElement(PasswordField, _extends({}, field, {
        onBlur: () => {
          logBI(10203, {
            isPasswordValid: !fieldState.error
          });
          field.onBlur();
        },
        error: fieldState.isTouched && !!fieldState.error,
        helperText: fieldState.isTouched && ((_fieldState$error4 = fieldState.error) === null || _fieldState$error4 === void 0 ? void 0 : _fieldState$error4.message),
        testid: "password-input"
      }));
    }
  }), /*#__PURE__*/React.createElement(SubmitButtonField, {
    disabled: !formState.isValid,
    isLoading: signupInProgress,
    "data-testid": "signup-button"
  }, "Continue")), /*#__PURE__*/React.createElement(FormSeparatorVertical, null, "Or"), /*#__PURE__*/React.createElement(VerticalFormFields, null, /*#__PURE__*/React.createElement(GoogleButton, {
    testid: "google-btn-sign-up",
    onAuthError: msg => {
      setErrorMessage(msg || errorMessages.generalSignupError);
      setSignupError(true);
    },
    onAuthSuccess: () => {
      history.push(routes.home);
    }
  }), /*#__PURE__*/React.createElement(IntuitButton, null)))), signupError && /*#__PURE__*/React.createElement(ErrorMessage, {
    "data-testid": "error-msg"
  }, errorMessage), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(TermsAndPrivacyMessage, {
    type: "signup"
  })));
}
function WaitingVerification(props) {
  const {
    email,
    onWrongEmail
  } = props;
  const {
    api
  } = useStoreActions();
  return /*#__PURE__*/React.createElement("div", {
    className: styles.waitingVerificationContainer
  }, /*#__PURE__*/React.createElement(EmailSentIllustration, null), /*#__PURE__*/React.createElement("div", {
    className: styles.title
  }, "We've sent a verification email"), /*#__PURE__*/React.createElement("div", {
    className: styles.subTitle
  }, "A verification email was sent to ".concat(email, ". Please open it and click the verification link.")), /*#__PURE__*/React.createElement(Footer, null, /*#__PURE__*/React.createElement(FooterText, null, "Didn't receive an email? "), /*#__PURE__*/React.createElement(FooterLink, {
    onClick: event => {
      event.preventDefault();
      api.auth.resendEmailVerification(email);
    },
    "data-testid": "resend-email-link"
  }, "Resend email"), /*#__PURE__*/React.createElement(FooterText, null, " | "), /*#__PURE__*/React.createElement(FooterLink, {
    onClick: event => {
      event.preventDefault();
      onWrongEmail();
    },
    "data-testid": "change-email-link"
  }, "Change email")));
}
export function SignupScreen() {
  const [email, setEmail] = useState('');
  const [step, setStep] = useState('signup');
  useEffect(() => {
    document.title = 'Anchor Signup';
  }, []);
  return /*#__PURE__*/React.createElement(UnauthorizedPageContainer, {
    testId: step,
    wideLayout: true
  }, step === 'signup' && /*#__PURE__*/React.createElement(SignupForm, {
    onSubmitted: email => {
      if (email) {
        setEmail(email);
        setStep('waiting-verification');
      }
    }
  }), step === 'waiting-verification' && /*#__PURE__*/React.createElement(WaitingVerification, {
    email: email,
    onWrongEmail: () => setStep('signup')
  }));
}